import React from "react";
import PropTypes from "prop-types";
import { VarinerTable } from "@/components";

const FIELDS = ["title", "status", "clientContact.firstName", "clientContact.lastName"];

const JobsTable = ({ jobs }) => {
  return <VarinerTable data={jobs?.data} fields={FIELDS} />;
};

JobsTable.propTypes = {
  jobs: PropTypes.any
};

export { JobsTable };
